/* eslint-disable react/prop-types */

import 'configs/errorReporting'
import Head from 'next/head'

import {config} from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import 'components/Icon/lib'
import 'scss/styles.scss'

import Meta, {DEFAULTS} from 'modules/common/components/Meta'
import ErrorPage from 'modules/common/components/ErrorPage'

if (process.browser) require('resize-observer-polyfill')

config.autoAddCss = false

const App = ({Component, pageProps, err}) => {
  const {pageTitle, additionalMeta, errorCode, errorTitle} = pageProps

  const title = pageTitle
    ? `${pageTitle} | ${DEFAULTS.title}`
    : `${DEFAULTS.title}: ${DEFAULTS.shortDescription}`

  return !errorCode ? (
    <>
      <Head>
        <title>{title}</title>
        <Meta additionalMeta={additionalMeta} />
      </Head>
      <Component {...pageProps} err={err} />
    </>
  ) : (
    <ErrorPage
      status={errorCode}
      title={errorTitle || 'Internal Server Error'}
    />
  )
}

export default App
